<script setup lang="ts">
import { type HTMLAttributes, computed } from 'vue';
import { DialogTitle, type DialogTitleProps, useForwardProps } from 'radix-vue';

import { cn } from '@/lib/utils';
import { createDelegatedProps } from '@/lib/helpers';

const props = defineProps<
  DialogTitleProps & { class?: HTMLAttributes['class']; testId?: string }
>();

const delegatedProps = computed(() =>
  createDelegatedProps<typeof props>(props)
);

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DialogTitle
    :data-testid="`${props.testId}-title`"
    v-bind="forwardedProps"
    :class="
      cn(
        'text-2xl text-gray-800 py-1 font-semibold leading-none tracking-tight',
        props.class
      )
    "
  >
    <slot />
  </DialogTitle>
</template>
